interface IModalContent {
  body: string
  subtitle: string
  title: string
}

type RedirectMessage =
  | 'codeCreationError'
  | 'remoteSiteSettingCreateFailed'
  | 'revenovaLoadObjectDoesNotExist'
  | 'success'
  | 'notFound'
  | 'unauthorized'
  | string
  | null

export interface IRedirectParams {
  app: string | null
  message: RedirectMessage
  redirected: string | null
  status: string | null
}

/**
 * This function is used to get the modal content for the enable app modal.
 */
export const getModalContent = (redirectParams: IRedirectParams): IModalContent => {
  const isInProgress = redirectParams.status === 'pending'
  const isSuccess = redirectParams.status === 'true' || redirectParams.status === 'success'

  if (isInProgress) {
    return {
      body: 'You will know the app is enabled if it says "Enabled" after you refresh the page.',
      subtitle: 'Refresh the page after 1 minute.',
      title: `Setting up ${redirectParams.app}`
    }
  }

  if (!isSuccess) {
    return {
      body: `Please email support at support@chaineapp.com with the following error code: ${redirectParams.message}`,
      subtitle: 'Please see why below.',
      title: 'Something went wrong'
    }
  }

  return {
    body: "You're all set, you can close this popup.",
    subtitle: '',
    title: `${redirectParams.app} is now enabled`
  }
}
